/* unplugin-vue-components disabled */import { render } from "./ComicsItemDetails.vue?vue&type=template&id=075cb076&scoped=true"
import script from "./ComicsItemDetails.vue?vue&type=script&lang=js"
export * from "./ComicsItemDetails.vue?vue&type=script&lang=js"

import "./ComicsItemDetails.vue?vue&type=style&index=0&id=075cb076&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075cb076"]])

export default __exports__